<template>
    <div class="detail">
        <div class="crumbs">
            <span class="crumbs_link" href="">首页</span>
            <span class="crumbs_separator">&gt;</span>
            <span class="crumbs_link">{{info.type==0?'企业报道':(info.type==1?'行业资讯':(info.type==2?'新闻资讯':(info.type==3?'高端访谈':(info.type==4?'经验分享':'会展报道'))))}}</span>
            <span class="crumbs_separator__25GUa">&gt;</span>
            <span class="crumbs_current">{{info.newTitle}}</span>
        </div>
        <div class="new-info">
            <div class="new-info_left">
                <h1 class="artilce_title">{{info.newTitle}}</h1>
                <p class="create-time">{{info.createTime}} 浏览量:{{info.num}}</p>
                <div style="margin-top: 30px;border-top: 1px solid #e5e5e5;text-align: left;"
                     v-html="info.newDetail"></div>
            </div>
            <div class="new-info_right">
                <div class="hot-new-info">
                    <h2 class="hotNews_title">相关新闻</h2>
                    <div style="width: 100%;height: 20px;"></div>
                    <div class="hot-new-info_item" v-for="(item,index) in rightList">
                        <div style="width: 40px;display: flex;align-items: flex-start;">
                            <div class="index-style index-one" v-if="index==0">{{index+1}}</div>
                            <div class="index-style index-tow" v-else-if="index==1">{{index+1}}</div>
                            <div class="index-style index-tree" v-else>{{index+1}}</div>
                        </div>
                        <div style="flex: 1;">
                            <div class="new-title" @click="openDetail(item.newId)">{{item.newTitle}}{{item.newTitle}}
                            </div>
                            <div class="hotNews_time">{{item.createTime}}</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>


    </div>

</template>

<script>
    import {getNewDetail, getNewList, updateHistory} from '../../api/new.js'

    export default {
        data() {
            return {
                rightList: [],
                info: {
                    newId: 0,
                    newTitle: '',
                    newDetail: '',
                    createTime: '',
                    type: 0
                },
                num: 0,
            }
        },
        created() {
            let self = this;
            this.info.newId = this.$route.query.id
            if (this.info.newId > 0) {
                this.getInfo()
            } else {
                this.$router.push({path: '/new/index'})
            }
            let t = setInterval(function () {
                self.num++;
                if (self.num >= 3) {
                    clearInterval(t);
                    self.updataNum();
                }
            }, 1000)
        },
        methods: {
            updataNum() {
                updateHistory(this.info.newId).then(res => {
                    console.log(res);
                })
            },
            openDetail(id) {
                this.$router.push({path: '/new/detail', query: {id: id}})
                location.reload()
            },
            getInfo() {
                getNewDetail(this.info.newId).then(res => {
                    this.info = res.data
                    getNewList({current: 1, size: 10, type: res.data.type}).then(res => {
                        console.log(res)
                        this.rightList = res.data.records
                    })
                })
            }
        }
    }
</script>

<style>
    a {
        text-decoration: none;
    }

    .detail {
        width: 1200px;
        margin: auto;
        min-height: calc(100vh - 180px);
        padding-top: 80px;
    }

    .crumbs {
        height: 40px;
        text-align: left;
        margin-top: 20px;
    }

    .crumbs .crumbs_link, .crumbs .crumbs_separator {
        color: #777;
        font-family: PingFangSC-Regular;
        font-size: 13px;
    }

    .crumbs .crumbs_current {
        color: #ff5800;
        font-family: PingFangSC-Regular;
        font-size: 13px;
    }

    .new-info {
        display: flex;
        min-width: 1200px;
        width: 1200px;
        margin: auto;

    }

    .new-info_left {
        flex: 1;
    }

    .new-info_right {
        width: 300px;
        text-align: right;
    }

    .artilce_title {
        color: #282828;
        font-family: PingFangSC-Semibold;
        font-size: 22px;
        line-height: 30px;
        padding: 20px 0 14px;
        text-align: left;
    }

    .hot-new-info {
        width: 94%;
        box-shadow: 0 0 4px 0 rgb(0 0 0 / 10%);
        min-height: 300px;
        margin-left: 6%;
        margin-top: 30px;
    }

    .hot-new-info_item {
        display: flex;
        padding: 10px 0;
        width: 94%;
        margin-left: 3%;
    }

    .hot-new-info_item .index-style {
        display: flex;
        align-items: center;
        justify-content: center;
        color: #ffffff;
        width: 20px;
        height: 20px;
        font-size: 12px;
    }

    .index-one {
        background-color: #f84521;
    }

    .index-tow {
        background-color: #ff6f24;
    }

    .index-tree {
        background-color: #ababab;
    }

    .new-title {
        color: #3b3b3b;
        cursor: pointer;
        font-size: 14px;
        line-height: 22px;
        position: relative;
        width: 225px;
        text-align: left;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        overflow: hidden;
        max-height: 44px;
    }

    .new-title:hover {
        color: #ff6f24;
    }

    .hotNews_time {
        color: #b8b8b8;
        display: block;
        font-family: HelveticaNeue;
        font-size: 14px;
        line-height: 16px;
        padding-top: 5px;
        text-align: left;
    }

    .hotNews_title {
        width: 94%;
        margin-left: 3%;
        border-bottom: 1px dashed #e6e8eb;
        color: #000;
        font-size: 14px;
        font-weight: 600;
        height: 58px;
        line-height: 58px;
        text-align: center;
    }

    .create-time {
        color: #b8b8b8;
        font-family: PingFangSC-Regular, PingFang SC;
        font-size: 13px;
        font-weight: 400;
        line-height: 18px;
        text-align: left;
    }
</style>